<template>
    <div id="Publish">
        <b-modal id="modPub" no-close-on-backdrop no-close-on-esc>
            <template v-slot:modal-header>
                {{ $t("PUBLISH")}}
                <b-button size="sm" @click="close()">x</b-button>
            </template>
            <b-form-radio-group v-if="!onlyCommon" id="radio-group-1" v-model="selected1" name="radio-sub-component">
                <b-form-radio value="common">{{ this.$t('ON_CMN_MAP') }}</b-form-radio>
                <b-form-radio value="private">{{ this.$t('ON_MY_MAP') }}</b-form-radio>
            </b-form-radio-group>
            <b-form-radio-group id="radio-group-2" v-model="selected2" name="radio2">
                <b-form-radio value="ru">{{ this.$t('RU') }}</b-form-radio>
                <b-form-radio value="en">{{ this.$t('EN') }}</b-form-radio>
            </b-form-radio-group>
            <template v-slot:modal-footer>
                <b-button @click.stop.prevent="showHelp=true"><font-awesome-icon icon="question" size="lg" :style="{ color: 'white' }" /></b-button>
                <b-button @click="save()">
                    {{ $t("SAVE")}}
                </b-button>
                <b-button @click="close()">
                    {{ $t("CLOSE")}}
                </b-button>
            </template>
        </b-modal>

        <Help
                v-on:closeHelp="showHelp=false"
                v-bind:helpName="helpName"
                v-if="showHelp"
        />

    </div>
</template>

<script>
import { BModal, BButton, BFormRadio, BFormRadioGroup } from 'bootstrap-vue';
import Help from "./Help.vue";

export default {
  name: 'Publish',
  components: {
    Help,
    BModal, BButton, BFormRadio, BFormRadioGroup
  },
  props: {
    userName: String,
    itemName: String,
    itemType: String,
    onlyCommon: Boolean
  },
  data: function() {
    return {
        selected1: 'common',
        selected2: 'ru',
        helpName: 'HelpPublish',
        showHelp: false
    }
  },
  mounted() {
    if(!this.$store.state.curUserName) this.$showErr(this.$t('TMOUT'), 401);
    this.publish();
  },
  methods: {
    async publish() {

        this.$bvModal.show('modPub');

        //await this.$bvModal.msgBoxOk(this.itemType);
    },
    async save() {
        this.$bvModal.hide('modPub')
        let url = this.itemType === 'places' ? '/publishPlace' :
            this.itemType === 'trips' ? '/publishTrip' : '/publishOuting';
        try {
            const response = await this.$http.get(url, {
                params: {
                    itemName: this.itemName,
                    userName: this.userName,
                    choice: this.selected1,
                    lang: this.selected2
                }
            });
            this.$showMsg(response.data);
            this.close();
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    close() {
        this.$bvModal.hide('modPub');
        this.$emit('reloadList');

    }
  }
}
</script>